import React, { useEffect, useState } from 'react';

export default function MenuImage({ src, alt, className = '', loading = 'lazy', fallback = 'No image' }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);
  return src && !broken
    ? <img src={src} alt={alt} loading={loading} decoding="async" className={className} onError={() => setBroken(true)} />
    : <div role="img" aria-label={`${alt}: no image`} className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`}>{fallback}</div>;
}
